import React from 'react';
import iconEmail from '../../../img/fichaConcesionario/icono_email.svg';
import iconTelefono from '../../../img/fichaConcesionario/icono_telefono.svg';
import iconContacto from '../../../img/fichaConcesionario/icono_contacto.svg';
import iconHora from '../../../img/fichaConcesionario/icono_hora_atencion.svg'

import { Col, Container, Row } from 'react-bootstrap';

import '../../../css/textsPredefined.css'


const InfoConcesionario = ({ datos }) => {

    if (!datos || datos.length < 0) return null;
    return (
        <Container className="mt-4 mt-lg-0" fluid>
            <Row>
                <Col xs={12} md={10} lg={9} className="mx-auto pr-0">
                    <Row className="pb-2">
                        <Col xs="auto">
                            <img src={iconTelefono} className="icon-info" alt="telefono" />
                        </Col>
                        <Col className="text-left px-0 pr-4 pr-md-0">
                            <p className="bold-title-hyundai mb-0 f-responsive">Teléfono</p>
                            <p className="parrafo-hyundai mb-0 f-responsive">{datos.Telefono}</p>
                        </Col>
                    </Row>
                    <Row className="pb-2">
                        <Col xs="auto">
                            <img src={iconContacto} className="icon-info" alt="Nombre-Contacto" />
                        </Col>
                        <Col className="text-left px-0 pr-4 pr-md-0">
                            <p className="bold-title-hyundai mb-0 f-responsive">Contacto</p>
                            <p className="parrafo-hyundai mb-0 f-responsive">{datos.Contacto}</p>
                        </Col>
                    </Row>
                    <Row className="pb-2">
                        <Col xs="auto">
                            <img src={iconEmail} className="icon-info" alt="email" />
                        </Col>
                        <Col className="text-left px-0 pr-4 pr-md-0">
                            <p className="bold-title-hyundai mb-0 f-responsive">Email</p>
                            <p className="parrafo-hyundai mb-0 f-responsive">{datos.Email}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="auto">
                            <img src={iconHora} className="icon-info" alt="horario-atencion" />
                        </Col>
                        <Col className="text-left px-0 pr-4 pr-md-0">
                            <p className="bold-title-hyundai mb-0 f-responsive">Hora de atención</p>
                            <Row>
                                <Col><p className="parrafo-hyundai mb-0 f-responsive">Lunes a Viernes:</p><p className="parrafo-hyundai mb-0 f-responsive">{datos.HorarioSemana ? datos.HorarioSemana + ' hrs' : '-'}</p></Col>
                                <Col><p className="parrafo-hyundai mb-0 f-responsive">Sábados:</p><p className="parrafo-hyundai mb-0 f-responsive">{datos.HorarioFinde && datos.HorarioFinde !== "0:00 - 0:00" ? datos.HorarioFinde + ' hrs' : '-'}</p></Col>
                            </Row>                            
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

export default InfoConcesionario;